<template>
  <transition name="popup" appear>
    <!--    <div class="popup popup-overlay">-->
    <div class="popup popup-overlay" v-if="activePopups > 0">
      <div class="popup-window" v-for="(popup, idx) in popups" :key="`popup_${popup.id}`">
        <div class="popup-content" v-if="popup.isOpen">
          <a :href="popup.link" target="_blank">
            <img :src="popup.image" :alt="popup.title">
          </a>
        </div>
<!--        <button type="button" class="btn-skip" v-if="popup.isOpen" @click="skip(idx)">오늘하루보지않기</button>-->
        <button v-if="popup.isOpen" class="btn btn-sm btn-close-save">
          <Checkbox id="checkboxCloseSave" v-model:checked="popup.checked">오늘 하루 보지 않기</Checkbox>
        </button>
        <button class="btn-close" @click="close(idx)" v-if="popup.isOpen">
          <i class="xi-close-thin"></i>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import apiPopup from "../api/popup";
import dayjs from "dayjs";
import Checkbox from "@/components/Checkbox";

export default {
  name: "ThePopup",
  components: {
    Checkbox
  },
  data() {
    return {
      popups: [],
      activePopups: 0,
      curIdx: 0,
    }
  },
  methods: {
    skip(idx) {
      localStorage.setItem(`skip_popup_${this.popups[idx].id}`, dayjs().format('YYYY-MM-DD'));
      this.close(idx);
    },
    close(idx) {
      if (this.popups[idx].checked) {
        localStorage.setItem(`skip_popup_${this.popups[idx].id}`, dayjs().format('YYYY-MM-DD'));
      }
      this.activePopups--;
      this.popups[idx].isOpen = false;
    },
    async loadPopup() {
      // this.popups = [
      //   {
      //     id: 1,
      //     link: 'https://dev.mrbob.kr/',
      //     title: '팝업테스트',
      //     image: 'https://via-bob-dev.s3.ap-northeast-2.amazonaws.com/popup/popupTest.png'
      //   },{
      //     id: 2,
      //     link: 'https://dev.mrbob.kr/support',
      //     title: '팝업테스트2',
      //     image: 'https://via-bob-dev.s3.ap-northeast-2.amazonaws.com/popup/popupTest2.png'
      //   },
      // ];

      this.popups = await apiPopup.getPopups();

      this.popups.forEach((item) => {
        let date = localStorage.getItem(`skip_popup_${item.id}`);
        let today = dayjs().format('YYYY-MM-DD');

        if (!date || (!dayjs(date).isSame(dayjs(today)) && dayjs(date).isBefore(dayjs(today)))) {
          item['isOpen'] = true;
          this.activePopups++;
        } else {
          item['isOpen'] = false;
        }
      })
    }
  },
  async mounted() {
    this.loadPopup();
  }
}
</script>

<style lang="scss">
.popup {
  .popup-header {
    font-family: SBAggroL;
    font-size: 25px;
    text-align: center;
  }

  .popup-body {
    padding-top: 40px;
  }

  .btn-close-save {
    position: absolute;
    top: -30px;
    left: -10px;
    padding: 0;
    background-color: transparent;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    height: 20px;

    span {
      display: inline-block;
      padding: 0px 0 0 6px;
      line-height: 18px;
    }

    .checkbox-group i {
      vertical-align: top;
      color: #fff;
    }
  }

  @include respond(mobile) {
    .btn-close-save {
      .checkbox-group {
        i {
          margin-top: 3px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.popup {

  &.popup-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  &-window {
    position: absolute;
    //overflow: hidden;
    //padding: 2.5rem 4.3rem;
    //@include border-round(20px);
  }

  &-content {
    //background: #000;
    //padding: 1.5rem;
  }

  &-footer {
    //background: #ccc;
    //padding: 1rem 1.5rem;
    text-align: right;
  }

  .btn-close {
    position: absolute;
    width: 35px;
    height: 35px;
    background-color: transparent;
    @include border-round(100%);
    border: 1px solid #fff;
    padding: 0;
    color: #fff;
    font-size: 20px;
    top: -49px;
    right: 0;
    cursor: pointer;
  }

  a {
    display: block;
  }

  img {
    width: 350px;
    max-height: 400px;
  }

  .btn-skip {
    background-color: transparent;
    color: #fff;
    height: 35px;
    border: none;
    outline: none;
    cursor: pointer;
    position: absolute;
    top: -50px;
    right: 50px;
  }

  @include respond(desktop) {
    img {
      width: 525px;
      max-height: 525px;
    }
  }
}

.popup-window {
  @include respond(mobile) {
    //width: 90%;

    img {
      max-width: 90vw;
      max-height: 80vh;
    }
  }
}

// 오버레이 트랜지션
.popup-enter-active, .popup-leave-active {
  transition: opacity 0.4s;

  // 오버레이에 포함되어 있는 모달 윈도의 트랜지션
  .popup-window {
    transition: opacity 0.4s, transform 0.4s;
  }
}

// 딜레이가 적용된 모달 윈도가 제거된 후에 오버레이가 사라짐
.popup-leave-active {
  transition: opacity 0.6s ease 0.4s;
}

.popup-enter, .popup-leave-to {
  opacity: 0;

  .popup-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}
</style>

